export class InlineButtonActions {
  constructor() {
    this.actions = {
      'try-modal': this.openTryModal.bind(this),
    };
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      const button = e.target.closest('[data-action]');
      if (!button) return;

      const action = button.dataset.action;
      if (this.actions[action]) {
        e.preventDefault();
        this.actions[action](button);
      }
    });
  }

  openTryModal(button) {
    const modal = document.getElementById('fontdue-testfont-modal');
    if (modal) {
      modal.open = true;
    } else {
      console.warn('Try modal not found');
    }
  }

  // Method to register additional actions if needed in the future
  registerAction(name, callback) {
    this.actions[name] = callback;
  }
}

export function initInlineButtonActions() {
  return new InlineButtonActions();
}
